<template>
  <div class="first-search-car-dialog">
    <van-popup v-model="showDialog">
      <div class="content">
        <div class="title">
          系统检测到您初次查询该车牌号：
        </div>
        <div class="vclNo">{{vno}}</div>
        <div class="remind">
          <div class="remind-title">海管家提醒您：</div>
          <div class="message">
            未征得车主同意，擅自查询其货车定位或 货车轨迹，由此带来的法律责任和风险将 由您个人自行承担。
          </div>
        </div>
        <div class="btn" @click="agreebtn">我已取得车主授权，继续查询</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    vclNo: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      vno: 'hisTrack/vno'
    }),
  },
  created () {},
  mounted () {},
  watch: {},
  methods: {
    /**
     * 显示开通体验vip弹框
    */
    showPopup () {
      this.showDialog = true
    },

    /**
     * 同意授权
    */
    agreebtn () {
      this.showDialog = false
      this.$emit('agree')
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.first-search-car-dialog>:first-child {
  background-color: rgba(0,0,0,.4)
}
.first-search-car-dialog>:last-child {
  width: 80%
}
.first-search-car-dialog {
  .content {
    padding: 30px 30px;
    background-color: #ffffff;
    .title {
      padding: 36px 0;
      text-align: center;
      font-size: 24px;
    }
    .vclNo {
      width:323px;
      height:70px;
      font-size: 28px;
      font-weight: bold;
      background-color:#F8F8F8;
      box-shadow:0px 5px 7px 0px rgba(179, 179, 179, 0.35);
      border-radius:35px;
      line-height: 70px;
      text-align: center;
      margin: 0 auto;
    }
    .remind {
      font-size: 24px;
      padding: 30px 30px;
      padding-top: 60px;
      .remind-title {
        color: #282828;
        font-weight: bold;
      }
      .message {
        color: #656565;
      }
    }
    .btn {
      background-color: #5572FD;
      color: #ffffff;
      font-size: 26px;
      border-radius: 40px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      margin: 30px 30px;
    }
  }
}
</style>
